/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://gis.clark.wa.gov/portal/jsapi/jsapi4/esri/copyright.txt for details.
*/
class t{constructor(){this.pan=0,this.rotate=0,this.fov=0,this.sourceZoom=0,this.targetZoom=0}}export{t as CompareResult};
